import { ERROR_PREFIXES } from 'src/common/constants';
import { API } from '../REST';
import { RESPONSE_TYPES } from '../REST/constants';
import { isBadStatus } from '../REST/utils/isBadStatus';

const settingsService = API.settings;
export type DisclaimerFromSettings = {
    disclaimerID: string;
    paramName?: string;
    paramValue?: string | boolean;
};
export type DisclaimerFromSettingsWithParamName = {
    disclaimerID: string;
    paramName: string;
    paramValue?: string | boolean;
};
export type SettingsResponse = {
    value: DisclaimerFromSettings[];
};
export const getPublicSettingsValues = async (key: string): Promise<DisclaimerFromSettings[]> => {
    const response = await settingsService.GET<SettingsResponse>({ action: `v1/public/values/${key}` });
    if (response.type === RESPONSE_TYPES.NETWORK_ERROR || isBadStatus(response.statusCode)) {
        const error = new Error(
            `${
                ERROR_PREFIXES.PUBLIC_SETTINGS_API
            } Failed to retrieve disclaimers from settings service for ${key}. Status Code ${
                response.type !== RESPONSE_TYPES.NETWORK_ERROR ? response.statusCode : null
            }`
        );
        throw error;
    }
    const { value } = response.data;
    return value;
};
